angular.module('impactx.list').directive('ixServerSideListDeprecatedFilter', function() {
    return {
        restrict: 'E',
        scope: {
            field: '=',
            suffix: '@',
            /* need access to the overall server-list controller */
            listController: '='
        },
        // require: '^stTable',
        template: '</md-input-container><md-checkbox ng-model="field.selected" ng-change="change()">{{suffix}}</md-checkbox>',
        link: function(scope/*, element, attr, ctrl*/) {

            scope.change = function() {
                if(impactX.isFunction(scope, 'listController.refreshData')) {
                    scope.listController.refreshData();
                }
            };
        }
    }
});
